import { AxiosPromise } from 'axios';
import { BaseRepository } from '@app/src/common/repository/BaseRepository';

export interface IPackageRelease {
  fileId: string;
  fileUrl: string;
  downloadUrl: string;
  version: string;
  description: string;
  createdBy: string;
  createdDate: string;
}

export interface IPlatformVersion {
  productVersion: string;
  assemblyVersion: string;
  fileVersion: string;
}

export interface IPackageReleaseResponse {
  packageReleases: IPackageRelease[];
  total: number;
}

class PackageRepository extends BaseRepository {
  packageReleasesUrl = `${this.deviceManagementUrl}/packageReleases`;

  public getPackageRelease(): Promise<IPackageReleaseResponse> {
    return this.callGet<IPackageReleaseResponse>(
      `${this.packageReleasesUrl}?packageName=FW.Agent&startIndex=0&endIndex=0`
    ).then(result => result.data);
  }

  public getPlatformVersion(): Promise<IPlatformVersion> {
    return this.callGet<IPlatformVersion>(
      `${this.userManagementUrl}/microservice/version`
    ).then(response => response.data);
  }

  public getPackageReleases(): Promise<IPackageReleaseResponse> {
    return this.callGet<IPackageReleaseResponse>(
      `${this.packageReleasesUrl}?packageName=FW.Agent`
    ).then(response => response.data);
  }
}

export default new PackageRepository();
